<template>
  <div class="row">
    <div class="col-12">
      <SectionTitle
        v-if="useHeaderTitle"
        class="my-2 pt-4"
        :has-line="true"
        :title="title"
      />

      <OrderedHeader :is-ordered="false" v-if="!collections.paramActivateAssistantServiceNeedGuideWasOn">
        <template v-slot:content>
          <div class="row">
            <div class="col-12">{{ questionText }}</div>
            <div
              class="col-12 d-flex align-items-start align-items-md-center mb-3"
            >
              <p class="m-0">
                Si el estudiante o grupo tuvo un asistente irregular, por
                remedio o compañía privada usted debe marcar No.
              </p>
            </div>
          </div>
        </template>
        <template v-slot:actions>
          <ValidationProvider
            v-slot="{ errors }"
            name="hasAssistantAvailable"
            rules="required"
          >
            <CustomRadio
              is-question-list
              custom-error-msg=""
              :class="[
                'ordered-header-card-custom-radio',
                { 'bg-error-outside': errors.length },
              ]"
              name="hasAssistantAvailable"
              :value="hasAssistantAvailable"
              :options="getYesNoOptions"
              :change-event="onChangeYesNo"
              :disabled="submitted"
            />
          </ValidationProvider>
        </template>
        <template v-slot:content-bottom>
          <slot v-if="showReason" name="reason" />
        </template>
      </OrderedHeader>
      <div class="col pt-5" v-else>
        <HeaderAssistantQuestion
          v-for="item in collections.servicessNeeds.filter(item => item.justifiedFlag)"
          :key="item.id"
          class="pb-3"
          :isDraft="false"
          :removeColHeader="true"
          :peiId ="collections.peiId"
          :id="item.id"
          :justify="item.justifiedFlag"
          :name="item.name"
          :studentId="collections.studentId"
          :validate="false"
          :inappropriate-conduct-alternative="0"
          @on-justified-flag-change="onJustifiedFlagChange"
        />
      </div>  

      <CustomError
        v-if="showNoResponseError"
        variant="no-border"
        message="Favor contestar Sí o No"
      />

      <SectionTitle
        v-if="!useHeaderTitle && hasAssistantAvailable"
        class="my-2 pt-4"
        :has-line="true"
        :title="title"
      />

      <DynamicFormList v-if="hasAssistantAvailable" :items="assistants">
        <template #items="{ item, index }">
          <div class="col-12">
            <DynamicFormListItem
              :item="item"
              :no-actions="submitted"
              class="bg-light-gray border-radius--light"
            >
              <template #default="{ active, toggle }">
                <AssistantInformationItem
                  :item="item"
                  :submitted="submitted"
                  cols="col-md col-12"
                >
                  <template v-if="!submitted && !active" #actions>
                    <div class="col pt-2 col-md-2 col-lg-2 px-0 ml-auto">
                      <div
                        class="d-flex align-items-center justify-content-end h-100 w-100"
                      >
                        <MenuDropDown
                          title="Acciones"
                          :items="[
                            {
                              label: 'Editar',
                              icon: 'fas fa-edit fa-fw text-green',
                              border: 'bottom',
                              click: toggle,
                            },
                            {
                              label: 'Eliminar',
                              icon: 'fas fa-times-circle fa-fw text-red',
                              click: () => remove(index),
                            },
                          ]"
                        />
                      </div>
                    </div>
                  </template>
                </AssistantInformationItem>
                <template v-if="!submitted && active">
                  <div class="delimiter" />
                  <AssistantInformationForm
                    :item="item"
                    :editting="active"
                    :collections="collections"
                    @submit="edit"
                    @cancel="toggle"
                  />
                </template>
              </template>
            </DynamicFormListItem>
          </div>
        </template>

        <template v-if="!submitted" #form="{ toggle }">
          <AssistantInformationForm
            :collections="collections"
            @submit="add"
            @cancel="toggle"
          />
        </template>

        <template v-if="!submitted" #form-toggler="{ toggle }">
          <div>
            <template v-if="showAddButtom">
              <div class="text-right">
                <ActionButton
                  text="Añadir"
                  variant="success"
                  i="fas fa-file-plus"
                  @click="toggle"
                />
              </div>
            </template>
            <template v-if="!hasAnyItems">
              <ActionButton
                type="activationButton"
                :text="principalButtonLabel"
                :class="{ invalid: validate }"
                @click="toggle"
              />
            </template>
            <CustomError
              v-if="validate"
              variant="no-border"
              :message="customErrorMsg"
            />
          </div>
        </template>
      </DynamicFormList>

      <div v-if="showSubmittedWarningText && submitted && !hasAnyItems && !collections.paramActivateAssistantServiceNeedGuideWasOn">
        <div class="bg-light-gray border-radius--light py-4 text-center">
          Al momento no cuenta con el personal en la escuela que pueda cubrir la
          necesidad de esta solicitud.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import MenuDropDown from 'dropdown';
import CustomError from 'custom-error';
import OrderedHeader from 'ordered-header-card';
import yesNoOptions from '@/utils/constants/hrrequest/yesNoOptions';
import { DynamicFormList, DynamicFormListItem } from '@/components/common';
import AssistantInformationForm from './components/AssistantInformationForm';
import AssistantInformationItem from './components/AssistantInformationItem';
import HeaderAssistantQuestion from "@/components/pei/tabs/components/tab6/HeaderAssistantQuestion";
export default {
  name: 'AssistantInformation',
  components: {
    SectionTitle,
    CustomRadio,
    ActionButton,
    MenuDropDown,
    CustomError,
    OrderedHeader,
    DynamicFormList,
    DynamicFormListItem,
    AssistantInformationForm,
    AssistantInformationItem,
    HeaderAssistantQuestion
  },
  props: {
    title: {
      type: String,
      default: 'Información del asistente',
    },
    questionText: {
      type: String,
      default:
        '¿Tiene un personal nombrado en la escuela que pueda cubrir la necesidad de esta solicitud?',
    },
    assistants: {
      type: Array,
      default: () => [],
    },
    hasAssistantAvailable: {
      type: Boolean,
      default: null,
    },
    showSubmittedWarningText: {
      type: Boolean,
      default: false,
    },
    useHeaderTitle: {
      type: Boolean,
      default: false,
    },
    collections: {
      type: Object,
      required: true,
    },
    customErrorMsg: {
      type: String,
      default: 'Favor documentar un asistente de servicio.',
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Firma requerida',
      },
    },
    principalButtonLabel: {
      type: String,
      default: 'Presione aquí para añadir asistente(s) de servicio(s)',
    },
    submitted: { type: Boolean, default: false },
    allowAddMore: { type: Boolean, default: true },
    validate: { type: Boolean, default: false },
    limitNewAsisstantsTo: { type: [Number, String], default: 0 },
  },
  computed: {
    getYesNoOptions() {
      return yesNoOptions.map((op) => ({
        ...op,
        check: this.hasAssistantAvailable == op.id,
        disabled: this.submitted,
      }));
    },
    hasAnyItems() {
      return this.assistants.length > 0;
    },
    newSignatures() {
      return this.assistants.filter((x) => !x.id);
    },
    hasAnyNewItems() {
      return this.newSignatures.length > 0;
    },
    showAddButtom() {
      if (
        +this.limitNewAsisstantsTo > 0 &&
        this.allowAddMore &&
        this.hasAnyNewItems
      ) {
        return this.newSignatures.length < +this.limitNewAsisstantsTo;
      }
      return this.allowAddMore && this.hasAnyItems;
    },
    showReason() {
      return this.hasAssistantAvailable != null && !this.hasAssistantAvailable;
    },
    showNoResponseError() {
      return this.validate && this.hasAssistantAvailable == null;
    },
  },
  methods: {
    onChangeYesNo(item) {
      if (item.id == this.hasAssistantAvailable) return;
      this.$emit('update:hasAssistantAvailable', item.id);
      this.$emit('update:validate', false);
    },
    add(item, reset) {
      this.$emit('update:validate', false);
      if (this.submitted) {
        return;
      }
      this.assistants.push(item);
      reset();
    },
    edit(item, reset) {
      if (this.submitted) {
        return;
      }
      const index = this.assistants.findIndex((x) => x.id === item.id);
      this.assistants.splice(index, 1, item);
      reset();
    },
    remove(index) {
      if (this.submitted) {
        return;
      }
      this.assistants.splice(index, 1);
    },
    onJustifiedFlagChange(item) {
      this.$emit("on-justified-flag-change", item);
    },
  },
  watch: {
    assistants: {
      handler() {
        this.$emit('input', this.hasAnyItems);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
::v-deep .invalid > button {
  background-color: #f7d7da;
  border: 1px solid #c5cdcf;
}
::v-deep .bg-error-outside > div > div {
  background: #ffebeb 0 0 no-repeat padding-box !important;
  border: 1px solid #c9545e !important;
}
::v-deep .bg-error-outside > div > div span.step-label {
  color: #c9545e;
}
::v-deep .bg-error-outside > div > div span.rounded-circle {
  border: 2px solid #c9545e !important;
}
.delimiter {
  border-top: 1px solid #e2e2e2;
  margin: 0.5rem 0;
}
</style>
